import Uiconstants from '../../lib/UIconstants';
import QuestWidgetController from '../../controllers/quest/QuestWidgetController';
import { COMPONENTS } from '../../lib/constants';
import { isDesktop } from 'react-device-detect';

let scale = isDesktop ? 1 : 2;

export const QuestWidget = {
	name: COMPONENTS.QUEST_WIDGET,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: QuestWidgetController,
			name: 'QuestWidgetController',
			config: {
				modal: Uiconstants.FTR_QUEST,
				items: [COMPONENTS.QUEST_PAGE, COMPONENTS.QUEST_PAGE_CLAIM]
			}
		}
	],
	components: [
		{
			name: Uiconstants.FTR_QUEST,
			type: 'SimpleButton',
			components: [
				{
					name: 'quest_widget_bg',
					type: 'MouseOverSprite',
					img: 'quest_widget_bg',
					imgHover: 'quest_widget_bg_hovered',
					position: { x: 50, y: 5 }
				},
				{
					name: 'fg',
					type: 'Sprite',
					components: [
						{
							name: 'fg',
							type: 'AnimatedSprite',
							position: { x: -5, y: -23 },
							animation: {
								pattern: '05_BookOff$.png',
								start: 0,
								end: 71,
								speed: 0.5,
								precision: 2,
								loop: true,
								scale: { x: 0.6 * scale, y: 0.6 * scale }
							}
						}
					]
				},
				{
					name: 'FTR_QUEST_TITLE',
					type: 'Text',
					position: { x: 84 + 45, y: 25 },
					text: 'QUEST_WIDGET_TITLE'
				},
				{
					name: 'FTR_QUEST_SUBTITLE',
					type: 'Text',
					position: { x: 84 + 45, y: 46 },
					text: 'QUEST_WIDGET_SUBTITLE'
				},
				{
					name: 'FTR_QUEST_TIMER',
					type: 'Text',
					position: { x: 200 + 45, y: 46 },
					text: 'QUEST_WIDGET_TIMER'
				}
			]
		}
	]
};
